module.exports = __webpack_public_path__ + "static/media/logo-andalucia.c3cbfe6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/logo-andalucia.png
// module id = 40
// module chunks = 0